import React, { useState, useEffect } from 'react';
import { Button, Col, Form, Row, Select } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import {
  useNavigate,
  createSearchParams,
  useLocation,
} from 'react-router-dom';

import Layout from '../../layouts/User';
import { getStates } from '../../services/api';
import Step from './step';
import { ORDER_SERVICE_CATEGORY } from '../../reducers/actions/orderService';

export type Props = {};

const ServiceSelectAddress: React.FC<Props> = (props) => {
  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const query = useQuery();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [states, setStates] = useState<any>([]);

  const loadStates = async (value: any) => {
    setStates(await getStates(value));
  };

  useEffect(() => {
    loadStates('');
  }, []);

  const onFinishForm = (value: any) => {
    const params = {
      ...value,
      category: query.get('category'),
    };
    navigate({
      pathname: '/services/jobs',
      search: `?${createSearchParams(params)}`,
    });
  };

  return (
    <>
      <Layout>
        <div style={{ paddingTop: '16px' }}>
          <Button type="link" onClick={() => navigate(-1)}>
            <LeftOutlined /> ย้อนกลับ
          </Button>
          <h1>
            ช่าง "
            {ORDER_SERVICE_CATEGORY[query.get('category') || '']}"
          </h1>
        </div>

        <div style={{ marginTop: '16px' }}>
          <Step current={0} />
          <br />
          <Form
            name="addressForm"
            onFinish={onFinishForm}
            layout="vertical"
            form={form}
          >
            <Row justify={'center'}>
              <Col span={12}>
                {' '}
                <Form.Item name={'province'} label="จังหวัด">
                  <Select
                    showSearch
                    filterOption={(input, option: any) =>
                      option.label.indexOf(input.toLowerCase()) >= 0
                    }
                    options={states}
                    placeholder="จังหวัด"
                  ></Select>
                </Form.Item>
              </Col>
            </Row>
            <Row justify={'center'}>
              <Col>
                <Form.Item>
                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    ค้นหาช่าง
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Layout>
    </>
  );
};

export default ServiceSelectAddress;
